import { colors } from "../../Styles";

export function DataParameter({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M85.4,54.7v-10.8c0-6-3.2-10.9-7-10.9h-5c-3.9,0-7,4.9-7,10.9v10.8H24.4v21.8h42v10.8c0,6,3.2,10.9,7,10.9h5c3.9,0,7-4.9,7-10.9v-10.8h173.6v-21.8H85.4Z"/>
      <path d="M209.4,121.3c0-6-3.2-10.9-7-10.9h-5c-3.9,0-7,4.9-7,10.9v10.8H24.4v21.8h166v10.8c0,6,3.2,10.9,7,10.9h5c3.9,0,7-4.9,7-10.9v-10.8h49.6v-21.8h-49.6v-10.8Z"/>
      <path d="M138.6,198.7c0-6-3.2-10.9-7-10.9h-5c-3.9,0-7,4.9-7,10.9v10.8H24.4v21.8h95.1v10.8c0,6,3.2,10.9,7,10.9h5c3.9,0,7-4.9,7-10.9v-10.8h120.5v-21.8h-120.5v-10.8h0Z"/>
    </svg>
  );
}
